import { html } from "lit";

export const fbIcon = (theme: string) => html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="${theme === "purple" ? "twf-fill-white" : "twf-fill-[#282828]"}"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 8.04868C16 3.60243 12.4194 0 8 0C3.58065 0 0 3.60243 0 8.04868C0 12.0659 2.92548 15.3957 6.75 16V10.3753H4.71774V8.04868H6.75V6.27538C6.75 4.25834 7.94355 3.14418 9.77161 3.14418C10.6471 3.14418 11.5626 3.30126 11.5626 3.30126V5.28097H10.5535C9.56 5.28097 9.25 5.9015 9.25 6.53793V8.04868H11.4687L11.1139 10.3753H9.25V16C13.0745 15.3957 16 12.0659 16 8.04868Z"
    />
  </svg>
`;
